import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/home/delete_icon.png';
import _imports_1 from '@/assets/img/home/wx_icon.png';
import _imports_2 from '@/assets/img/home/phone_img.png';
const _withScopeId = n => (_pushScopeId("data-v-6ed8a653"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content-body"
};
const _hoisted_2 = {
  class: "login-title"
};
const _hoisted_3 = {
  class: "code-body"
};
const _hoisted_4 = {
  key: 1,
  class: "qrcode-body"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "请使用微信扫小程序码登录", -1));
const _hoisted_6 = {
  class: "code-img"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 0,
  src: _imports_1,
  alt: ""
};
const _hoisted_9 = {
  key: 1,
  src: _imports_2,
  alt: ""
};
const _hoisted_10 = {
  class: "wx-name"
};
import { getQrCode, getQrInfo, getPhoneCode, loginPhone } from "@/api/login";
import { userStore } from "@/stores/modules/user";
import { ElMessage, ElLoading } from "element-plus";
// 获取链接参数
const __default__ = defineComponent({
  name: "loginDialog"
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    showLogin: {
      type: Boolean,
      default: false
    }
  },
  emits: ["changeShow", "success"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      showLogin
    } = toRefs(props);
    const userState = userStore();
    const ruleFormRef = ref();
    const ruleForm = reactive({
      mobile: "",
      verificationCode: "",
      loginSide: "user"
    });
    const timeLimit = ref(61);
    const isLoginMobile = ref(true);
    const qrImage = ref("");
    const timer = ref();
    const newTime = ref(new Date().getTime());
    const rules = reactive({
      mobile: [{
        required: true,
        message: "请输入手机号码",
        trigger: "blur"
      }, {
        validator: (rules, value, callback) => {
          !/^1(3|4|5|6|7|8|9)\d{9}$/.test(value) ? callback(new Error("请输入正确的手机号码")) : callback();
        },
        trigger: "change"
      }],
      verificationCode: [{
        required: true,
        message: "请输入手机验证码",
        trigger: "blur"
      }, {
        min: 4,
        max: 6,
        message: "请输入6位数有效验证码",
        trigger: "blur"
      }]
    });
    const countDown = () => {
      timeLimit.value--;
      const timmer = setInterval(() => {
        if (timeLimit.value > 0) {
          timeLimit.value--;
        } else {
          clearInterval(timmer);
          timeLimit.value = 61;
        }
      }, 1000);
    };
    const getQueryString = url => {
      let ItemArr = [];
      let ItemObj = {};
      url.substring(url.lastIndexOf("?") + 1, url.length).split("&").map(item => {
        ItemArr.push(item.split("="));
      });
      ItemArr.map(item => {
        ItemObj[item[0]] = item[1];
      });
      return ItemObj;
    };
    const getUserInfo = () => {
      let url = decodeURIComponent(location.href);
      if (getQueryString(url).userInfo) {
        let info = JSON.parse(getQueryString(url).userInfo);
        userState.login(info);
      }
    };
    getUserInfo();
    const getCode = () => {
      ruleFormRef.value.validateField("mobile").then(() => {
        getPhoneCode(ruleForm.mobile);
        countDown();
      }).catch(() => {});
    };
    const openLoading = () => {
      const loading = ElLoading.service({
        lock: true,
        text: "正在请求登录中...",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 1000);
    };
    const submitForm = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          const loading = ElLoading.service({
            lock: true,
            text: "正在请求登录中...",
            background: "rgba(0, 0, 0, 0.7)"
          });
          loginPhone(ruleForm).then(res => {
            if (res.code == 0) {
              userState.login(res.data);
              closeEvent();
              emit("success");
              nextTick(() => {
                init();
              });
            } else {
              ElMessage({
                message: res.msg,
                type: "warning"
              });
            }
            loading.close();
            stop();
          });
          console.log("submit!");
        } else {
          console.log("error submit!", fields);
        }
      });
    };
    const loginTypeEvent = () => {
      isLoginMobile.value = !isLoginMobile.value;
    };
    const fetchData = () => {
      getQrCode({
        currentTimeMillis: newTime.value
      }).then(res => {
        qrImage.value = res.data;
      });
    };
    const fetchInfoData = () => {
      getQrInfo({
        currentTimeMillis: newTime.value
      }).then(res => {
        if (res.data) {
          openLoading();
          userState.login(res.data);
          emit("success");
          closeEvent();
          init();
          stop();
        }
      });
    };
    const init = () => {
      isLoginMobile.value = true;
      ruleForm.mobile = "";
      ruleForm.verificationCode = "";
    };
    const closeEvent = () => {
      emit("changeShow", false);
    };
    const stop = () => {
      clearInterval(timer.value);
      timer.value = null;
    };
    watch(isLoginMobile, (newValue, oldValue) => {
      if (!newValue) {
        timer.value = window.setInterval(() => {
          setTimeout(fetchInfoData, 0);
        }, 1000);
      } else {
        stop();
      }
    });
    watch(showLogin, (newValue, oldValue) => {
      if (newValue) {
        fetchData();
        init();
      }
      stop();
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: _unref(showLogin),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(showLogin) ? showLogin.value = $event : null),
        class: "login-dialog ::v-deep .el-dialog",
        "show-close": false,
        "close-on-click-modal": false
      }, {
        header: _withCtx(() => [_createElementVNode("div", {
          class: "delete-body"
        }, [_createElementVNode("img", {
          onClick: closeEvent,
          src: _imports_0,
          alt: ""
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_unref(isLoginMobile) ? "登 录" : "扫码登录"), 1), _unref(isLoginMobile) ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: _unref(ruleForm),
          rules: _unref(rules),
          class: "login-ruleForm",
          size: "large",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              class: "form-input",
              modelValue: _unref(ruleForm).mobile,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(ruleForm).mobile = $event),
              placeholder: "请输入手机号",
              onKeyup: _cache[1] || (_cache[1] = _withKeys($event => submitForm(_unref(ruleFormRef)), ["enter"]))
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            prop: "verificationCode"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
              class: "input-code",
              modelValue: _unref(ruleForm).verificationCode,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(ruleForm).verificationCode = $event),
              placeholder: "请输入短信验证码",
              onKeyup: _cache[3] || (_cache[3] = _withKeys($event => submitForm(_unref(ruleFormRef)), ["enter"]))
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              class: "code-btn",
              onClick: getCode,
              disabled: _unref(timeLimit) !== 61
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(timeLimit) == 61 ? "获取验证码" : _unref(timeLimit) + "秒后重新发送"), 1)]),
              _: 1
            }, 8, ["disabled"])])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "login-btn",
              onClick: _cache[4] || (_cache[4] = $event => submitForm(_unref(ruleFormRef)))
            }, "登录")]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: _unref(qrImage),
          alt: ""
        }, null, 8, _hoisted_7)])])), _createElementVNode("div", {
          onClick: loginTypeEvent,
          class: "login-type"
        }, [_unref(isLoginMobile) ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9)), _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(isLoginMobile) ? "使用微信扫码登录" : "使用手机号登录"), 1)])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});